import React from 'react'
import ResearchHelpContentSkeleton from './ResearchHelpContentSkeleton'

export default function ResearchHelpTabsSkeleton(): JSX.Element {
  // The Research Help page renders Third Party Hints, so its skeleton reserves it too.
  return <ResearchHelpContentSkeleton showMyHeritageHints />
}
